import { render } from "./kanbanBoard.vue?vue&type=template&id=253c242c"
import script from "./kanbanBoard.vue?vue&type=script&lang=js"
export * from "./kanbanBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__